//functions to calculate baseball metrics.

//basic helpers functions:

const stringToFloat = (string) => {
    return parseFloat(string);
};

const check = (value, onNaN) => {
    return isNaN(value) || value === "Infinity" ? onNaN : value;
};

const d = (value, onNaN) => {
    return isNaN(value) ? onNaN : value === "Infinity" ? "Inf" : value;
};

const replaceInfinity = (value) => {
    return value === "Infinity" ? "Inf" : value;
};

const format = (number, onNaN, decimals) => {
    const toText = number.toFixed(decimals);
    if (toText[0] === "0") {
        return check(` ${toText.substr(1, toText.length)}`, onNaN);
    } else {
        return check(toText, onNaN);
    }
};

//functions for batters (hitters):

const avg = (h, ab) => {
    return format(stringToFloat(h) / stringToFloat(ab), ".000", 3);
};

const obp = (h, bb, hbp, ab, sf) => {
    return format(
        (stringToFloat(h) + stringToFloat(bb) + stringToFloat(hbp)) /
            (stringToFloat(ab) +
                stringToFloat(bb) +
                stringToFloat(hbp) +
                stringToFloat(sf)),
        ".000",
        3
    );
};

const slg = (tb, ab) => {
    return format(stringToFloat(tb) / stringToFloat(ab), ".000", 3);
};

const ops = (obp, slg) => {
    return format(stringToFloat(obp) + stringToFloat(slg), ".000", 3);
};

//functions for pitchers...

const pct = (wp, decp) => {
    return format(stringToFloat(wp) / stringToFloat(decp), ".000", 3);
};

const era = (erp, ipp) => {
    return d((9 * (stringToFloat(erp) / stringToFloat(ipp))).toFixed(2), "0.00");
};

const whip = (hp, bbp, ipp) => {
    return d(
        ((stringToFloat(hp) + stringToFloat(bbp)) / stringToFloat(ipp)).toFixed(2),
        "0.00"
    );
};

//functions from globalData...

const yearOps = (oba1, oba2, tb, ab) => {
    return check(
        (
            stringToFloat(oba1) / stringToFloat(oba2) +
            stringToFloat(tb) / stringToFloat(ab)
        ).toFixed(3),
        "0"
    );
};

const calcOpsPlus = (obp, seasonObp, slg, seasonSlg) => {
    const obpCalc = stringToFloat(obp) / stringToFloat(seasonObp);
    const slgCalc = stringToFloat(slg) / stringToFloat(seasonSlg);
    const opsPlusCalc = ((obpCalc + slgCalc - 1) * 100).toFixed(0);
    return replaceInfinity(check(opsPlusCalc, "0"));
}

const eraPlus = (eraS, eraP) => {
    return replaceInfinity(
        check((stringToFloat(eraS) / stringToFloat(eraP)) * 100, 0).toFixed()
    );
};

const fip = (hrp, bbp, hbpp, sop, ipp, fipconst) => {
    const e = 13 * stringToFloat(hrp);
    const f = 3 * (stringToFloat(bbp) + stringToFloat(hbpp));
    const g = 2 * stringToFloat(sop);
    const h = stringToFloat(ipp);
    return check(((e + f - g) / h + stringToFloat(fipconst)).toFixed(2), "0.00");
};

export { avg, obp, slg, ops, yearOps, calcOpsPlus, pct, era, whip, fip, eraPlus };
